module.exports = __webpack_public_path__ + "static/media/fruits_14.94ec7343.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_14.csv
// module id = 678
// module chunks = 0